import { MaskedInputNumber } from './MaskedInputNumber.main';

export { MaskedInputNumber };
